export default function stopAllVideos() {
  document.querySelectorAll('video').forEach((video) => video.pause())
}
